import * as React from "react";
import Button from '@material-ui/core/Button';
import AddIcon from '@material-ui/icons/Add';
import { useTranslation } from 'react-i18next';


// All the incoming values
interface IProps {
    disabled?: boolean;
}

// Outgoing functions
interface IDispatch {
    onClick: () => void
}

// Actual Component
export type AllProps = IProps & IDispatch;
export const CreateFileButton = (props: AllProps) => {
    const { t } = useTranslation('common');
    return (<Button startIcon={<AddIcon />} disabled={props.disabled} onClick={e => {e.stopPropagation(); props.onClick && props.onClick()}} variant="contained" color="primary">{t('createFile')}</Button>)
}

